module.exports = __webpack_public_path__ + "img/BAWS_Scythe1_3_2.7b464dcf.png";